import {Component, Input} from '@angular/core';
import {IconColourEnum} from '../../../../shared-modules/shared-icons/models/icons-colour.enum';
import {
  ISharedModalInputOne,
  ISharedModalInputOneResponse,
} from '../../../shared-models/modals/shared-modal-input-one';
import {IconsEnum} from '../../../../shared-modules/shared-icons/models/icons.enum';
import {ModalControllerService} from '../../../shared-services/overlay/modal-controller.service';
import {PopoverControllerService} from '../../../shared-services/overlay/popover-controller.service';

@Component({
  selector: 'app-shared-modal-input-one',
  templateUrl: './shared-modal-input-one.component.html',
  styleUrls: ['./shared-modal-input-one.component.scss'],
  standalone: false,
})
export class SharedModalInputOneComponent implements ISharedModalInputOne {

  icons: typeof IconsEnum = IconsEnum;

  @Input() buttonAccept: boolean;
  @Input() buttonAcceptText: string;
  @Input() buttonClose: boolean;
  @Input() buttonCloseCross: boolean;
  @Input() buttonCloseText: string;
  @Input() buttonSecondary: boolean;
  @Input() buttonSecondaryText: string;
  @Input() inputHeading: string;
  @Input() inputPlaceholder: string;
  @Input() inputText: string | number | Date;
  @Input() inputType: 'string' | 'number';
  @Input() modalTitle: string;
  @Input() modalTitleIcon: IconsEnum;
  @Input() modalTitleIconColor: IconColourEnum = IconColourEnum.white;
  @Input() contextHeading: string;
  @Input() contextDescription: string[];

  constructor(
    private modalController: ModalControllerService,
  ) {
  }

  @Input() set popoverReference(popoverController: PopoverControllerService) {
    void popoverController.dismiss().then();
  }

  onButtonPress(buttonPressed: 'button-accept' | 'button-secondary' | 'button-close'): void {
    void this.modalController.dismiss(
      {buttonPressed, inputText: this.inputText} as ISharedModalInputOneResponse,
      buttonPressed === 'button-accept' ? 'modal-accept' : 'modal-close',
    ).then((returned: boolean) => returned);
  }

}
